<template>
  <div class="flex items-baseline gap-3 py-2 border-b border-[#f0f2f4]">
    <span
      class="font-[Poppins] font-bold text-[11px] text-[#6c7a77] min-w-[140px] tracking-[0.5px]"
      >{{ name }}</span
    >
    <code
      class="font-mono text-[13px] text-[#191c1e] bg-[#f2f4f6] px-2 py-0.5 rounded-[6px]"
      >{{ value }}</code
    >
    <span
      v-if="note"
      class="font-[Plus_Jakarta_Sans] text-[12px] text-[#a0b0ae]"
      >{{ note }}</span
    >
  </div>
</template>

<script setup>
defineProps({ name: String, value: String, note: String });
</script>
